import { FC, useContext, useEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Select, Tag } from 'antd';
import { getConfig, sendNotification } from 'utils/helperMethods';
import { ActiveLenseConfig, AttributeTypeItem } from 'types/pricingSimulator';
import { pricingSimulatorWrapperDataContext } from 'contexts/PricingSimulatorWrapperContext';
import { ConfigKeys } from 'utils/Enums';
import { UserContext } from 'contexts/ConfigContext';

export const CustomSelect = styled(Select)`
    .ant-select-arrow-loading {
        color: blue !important;
        font-size: 16px;
    }
    .ant-select-selector {
        border-radius: 6px !important;
    }
    &.ant-select-multiple .ant-select-selection-item-remove {
        position: relative;
        top: -2px;
    }
`;

type Props = {
    onPopupClose: (tempSelectedDimensionList: AttributeTypeItem[]) => void;
    dimensionInfo: {
        activeLense?: ActiveLenseConfig;
        dimAttributes: AttributeTypeItem[];
    } | null;
    selectedDimensionListValues: string[];
};

const DimSection: FC<Props> = ({ onPopupClose, selectedDimensionListValues, dimensionInfo }) => {
    const { dimensionConfigData } = useContext(pricingSimulatorWrapperDataContext);
    const { dim1DropdownList = [], dim2DropdownList = [], lowestDimLensNames = [] } = dimensionConfigData ?? {};
    const { appConfig } = useContext(UserContext);
    const pricingSimulatorConfig = getConfig(ConfigKeys?.PRICING_SIMULATOR, appConfig);
    const { dimAttributesLimit } = pricingSimulatorConfig;
    const [tempSelectedDimensionList, setTempSelectedDimensionList] = useState<AttributeTypeItem[]>([]);
    const isLowestDimSelected = lowestDimLensNames?.includes(
        dimensionInfo?.activeLense?.activeLenseData?.lenseName?.toLocaleLowerCase() ?? '',
    );

    const listToDisplay = useMemo(() => {
        return [
            { label: 'Product', options: dim1DropdownList },
            { label: 'Geo', options: dim2DropdownList },
        ];
    }, [dim1DropdownList, dim2DropdownList]);

    // set default values when its empty
    // useEffect(() => {
    //     if (!selectedScenarioInfo?.dim1Attribute) {
    //         updateScenarioProperty('dim1Attribute', dim1DropdownList[0].value);
    //         updateScenarioProperty('dim2Attribute', dim2DropdownList[0].value);
    //     }
    // }, [selectedScenarioInfo?.dim1Attribute]);

    useEffect(() => {
        setTempSelectedDimensionList(dimensionInfo?.dimAttributes ?? []);
    }, [selectedDimensionListValues]);

    return (
        <div className="">
            <div className="flex gap-3 p-2">
                <CustomSelect
                    disabled={isLowestDimSelected}
                    style={{ width: '100%' }}
                    mode="multiple"
                    placeholder="Multiple Select"
                    maxTagCount="responsive"
                    //   maxTagCount={2}
                    tagRender={(val) => {
                        return (
                            <Tag className="rounded" closable={false}>
                                {val?.label}
                            </Tag>
                        );
                    }}
                    //  maxTagTextLength={7}
                    showArrow
                    onDropdownVisibleChange={(open) => {
                        if (!open) {
                            onPopupClose(tempSelectedDimensionList);
                        }
                    }}
                    showSearch={false}
                    value={tempSelectedDimensionList?.map((item) => item?.value)}
                    onChange={(val: any, item: any) => {
                        if (val?.length > dimAttributesLimit)
                            return sendNotification(
                                'error',
                                `You can select a maximum of ${dimAttributesLimit} attributes`,
                            );

                        return setTempSelectedDimensionList(item);
                    }}
                    options={listToDisplay}
                />
                {/* <CustomSelect
                    style={{ width: '100%' }}
                    value={selectedScenarioInfo?.dim1Attribute}
                    onChange={(val: any) => {
                        updateScenarioProperty('dim1Attribute', val);
                        updateScenarioProperty('offset', 0); //reset offset
                        setDimensionCheckboxObj({}); // reset checkbox
                        //update sort function if this column is active
                        if (selectedScenarioInfo?.sortObject?.sortBy === selectedScenarioInfo?.dim1Attribute) {
                            updateScenarioProperty('sortObject', {
                                sortBy: val || '',
                                sortingOrder: selectedScenarioInfo?.sortObject?.sortingOrder || 'asc',
                                sortType: 'actual',
                            });
                        }
                    }}
                    options={dim1DropdownList}
                    disabled={isLowestDimSelected}
                />
                <CustomSelect
                    style={{ width: '100%' }}
                    value={selectedScenarioInfo?.dim2Attribute}
                    onChange={(val: any) => {
                        updateScenarioProperty('dim2Attribute', val);
                        updateScenarioProperty('offset', 0);
                        setDimensionCheckboxObj({});
                        //update sort function if this column is active
                        if (selectedScenarioInfo?.sortObject?.sortBy === selectedScenarioInfo?.dim2Attribute) {
                            updateScenarioProperty('sortObject', {
                                sortBy: val || '',
                                sortingOrder: selectedScenarioInfo?.sortObject?.sortingOrder || 'asc',
                                sortType: 'actual',
                            });
                        }
                    }}
                    options={dim2DropdownList}
                    disabled={isLowestDimSelected}
                /> */}
            </div>
        </div>
    );
};

export default DimSection;
